
import { httpservice } from '../services';
import { constants } from '../constant/constant';
import {ENTITY} from '../constant';
import {httpserviceWithMultipart} from "../services/HttpServices";
import {WHAT_I_CAN_DO} from '../constant/actionTypes';
let apiEndPoint = constants.ADMIN_URL;

export const doWhatICanDoCreate = data => {
    return httpserviceWithMultipart('post', data, `${apiEndPoint}${constants.API.WHAT_I_CAN_DO}`)
        .then( (response) => {
            console.log(response)

            return {status:1,data:response.data};
        })
        .catch(function (error) {
            return {status:0,data:error.response && error.response.data ? error.response.data : error};
        });

};

export const doWhatICanDoDelete = Id => {
    const endPointUri = constants.API.WHAT_I_CAN_DO_BY_ID.replace(ENTITY.WHAT_I_CAN_DO_ID, Id);
    return httpservice()
        .delete(endPointUri)
        .then(function (response) {
            return {status:1,data:response.data};
        })
        .catch(function (error) {
            return {status:0,data:error.response && error.response.data ? error.response.data : error};
        });
};

export const doWhatICanDoUpdate = (Id, data) => {
    const endPointUri = constants.API.WHAT_I_CAN_DO_BY_ID.replace(ENTITY.WHAT_I_CAN_DO_ID, Id);
    
    return httpserviceWithMultipart('put', data, `${apiEndPoint}${endPointUri}` )
        .then(function (response) {
            return {status:1,data:response.data};
        })
        .catch(function (error) {
            return {status:0,data:error.response && error.response.data ? error.response.data : error};
        });
};
